<!-- info  -->
<ng-container *ngIf="config.status == statusTypes.info">
  <div mat-dialog-title class="tw-flex-center tw-flex-col !tw-mt-0">
    <i class="text-info tw-mx-1 tw-text-6xl mdi mdi-information"></i>
    <span>
      {{ config.title | translate }}
    </span>
  </div>
  <div mat-dialog-content [innerHTML]="config.message | translate"></div>
  <div mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      class="bg-light"
      (click)="onClickOkButton()"
    >
      {{ "common.ok" | translate }}
    </button>
  </div>
</ng-container>
<!-- success -->
<ng-container *ngIf="config.status == statusTypes.success">
  <div mat-dialog-title class="tw-text-center">
    <i class="fas fa-check-circle tw-text-6xl tw-p-1 text-gradient-success"></i>
  </div>
  <div
    mat-dialog-title
    class="tw-text-center tw-text-2xl text-success tw-mb-[10px]"
  >
    {{ config.title | translate }}
  </div>
  <div
    mat-dialog-content
    class="tw-text-center tw-text-gray-800 dark:tw-text-gray-300"
    [innerHTML]="config.message | translate"
  ></div>
  <div
    mat-dialog-actions
    class="tw-justify-center tw-min-h-20"
    style="margin-bottom: 12px"
  >
    <button
      mat-button
      mat-dialog-close
      class="bg-light !tw-min-w-[100px] !tw-min-h-[50px]"
      (click)="onClickOkButton()"
    >
      {{ "common.ok" | translate }}
    </button>
  </div>
</ng-container>
<!-- error -->
<ng-container *ngIf="config.status == statusTypes.error">
  <div mat-dialog-title class="tw-text-center">
    <i class="far fa-times-circle tw-text-6xl tw-p-1 text-gradient-danger"></i>
  </div>
  <div
    mat-dialog-title
    class="tw-text-center text-danger tw-text-2xl tw-mb-[10px] tw-flex tw-items-center tw-align-middle tw-content-center"
  >
    {{ config.title | translate }}
  </div>
  <div mat-dialog-content>
    <div
      [innerHTML]="config.message | translate"
      class="tw-break-words tw-text-center tw-text-gray-800 dark:tw-text-gray-300 tw-text-[16px]"
      style="line-height: 22px; max-width: 30rem"
    ></div>
  </div>
  <div
    mat-dialog-actions
    class="tw-justify-center tw-min-h-20"
    style="margin-bottom: 12px"
  >
    <button
      mat-button
      mat-dialog-close
      class="bg-light !tw-min-w-[100px] !tw-min-h-[50px]"
      (click)="onClickOkButton()"
    >
      {{ "common.ok" | translate }}
    </button>
  </div>
</ng-container>
<!-- warning -->
<ng-container *ngIf="config.status == statusTypes.warning">
  <div mat-dialog-title class="tw-text-center">
    <i class="fas fa-exclamation-circle text-warning tw-text-6xl tw-p-1"></i>
  </div>
  <div mat-dialog-title class="tw-text-center tw-text-2xl tw-mb-[10px]">
    {{ config.title | translate }}
  </div>
  <div
    mat-dialog-content
    [innerHTML]="config.message | translate"
    class="tw-text-center"
    style="line-height: 22px; text-align: center; max-width: 30rem"
  ></div>
  <div
    mat-dialog-actions
    class="tw-justify-center tw-min-h-20"
    style="margin-bottom: 12px"
  >
    <button
      mat-button
      mat-dialog-close
      class="bg-light !tw-min-w-[100px] !tw-min-h-[50px]"
      (click)="onClickOkButton()"
    >
      {{ "common.ok" | translate }}
    </button>
  </div>
</ng-container>
<!-- login -->
<ng-container *ngIf="config.status == statusTypes.login">
  <div mat-dialog-title class="tw-text-center">
    <i class="far fa-times-circle tw-text-6xl tw-p-1 text-danger"></i>
  </div>
  <div mat-dialog-title class="tw-text-center tw-text-2xl tw-mb-[10px]">
    {{ config.title | translate }}
  </div>
  <div mat-dialog-content>
    <div [innerHTML]="config.message" class="tw-text-center"></div>
  </div>
  <div
    mat-dialog-actions
    class="tw-justify-center tw-min-h-20"
    style="margin-bottom: 12px"
  >
    <button
      mat-ripple
      (click)="onRedirectToLogin()"
      class="btn btn-light tw-w-full tw-flex-center"
    >
      <span
        [inlineSVG]="'/assets/media/icons/duotune/global/login.svg'"
        class="svg-icon svg-icon-2x tw-mx-0"
      ></span>
      <span class="tw-mx-2 dark:tw-text-gray-200">
        {{ "common.login" | translate }}</span
      >
    </button>
  </div>
</ng-container>
<!-- register -->
<ng-container *ngIf="config.status == statusTypes.register">
  <div mat-dialog-title class="tw-text-center tw-w-[380px]">
    <i class="fas fa-check-circle text-success tw-text-6xl"></i>
  </div>
  <div mat-dialog-title class="tw-text-center tw-text-2xl tw-mb-[10px]">
    {{ config.title | translate }}
  </div>
  <div mat-dialog-content>
    <div [innerHTML]="config.message" class="tw-text-center"></div>
  </div>
  <div mat-dialog-actions class="tw-justify-center" style="min-height: 80px">
    <button
      mat-ripple
      (click)="onRedirectToLogin()"
      class="btn btn-light tw-w-full tw-flex-center"
    >
      <span
        [inlineSVG]="'/assets/media/icons/duotune/global/login.svg'"
        class="svg-icon svg-icon-2x tw-mx-0"
      ></span>
      <span class="tw-mx-2 dark:tw-text-gray-200">
        {{ "common.loginToAccount" | translate }}</span
      >
    </button>
  </div>
</ng-container>
<!-- copyableText -->
<ng-container *ngIf="config.status == statusTypes.copyableText">
  <div mat-dialog-title class="tw-text-center tw-mb-0">
    <i class="mdi mid-40px mdi-note-text-outline tw-text-6xl text-success"></i>
  </div>
  <div mat-dialog-title class="tw-text-center tw-text-2xl tw-mb-[15px]">
    {{ config.title | translate }}
  </div>

  <div
    mat-dialog-content
    class="copyable-text"
    copyToClipboard
    [innerHTML]="config.message | translate"
  ></div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ "common.ok" | translate }}</button>
  </div>
</ng-container>
